import { render } from "./LineChartC.vue?vue&type=template&id=63677107&scoped=true"
import script from "./LineChartC.vue?vue&type=script&lang=ts"
export * from "./LineChartC.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-63677107"

export default script